import { createContext } from 'react';

interface WidgetModalContextValue {
  portalRef: React.RefObject<HTMLElement | null>;
  isReady: boolean;
}

export const WidgetModalContext = createContext<WidgetModalContextValue | null>(
  null,
);
